const filterData = (data, jurisdiction) => {
  const offerList = data.filter(offer => {
    if (offer.jurisdictionList.includes(jurisdiction)) {
      return offer;
    }
    return null;
  });
  return offerList;
};

export default filterData;
